import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import FormHelperText from "@material-ui/core/FormHelperText";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Switch from "@material-ui/core/Switch";
import TextField from "@material-ui/core/TextField";
import React from "react";
import { languages } from "../../constants/languages";

export default class CustomPointsDialog extends React.Component {
  render() {
    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.toggleDialog}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {this.props.playerStats
            ? languages.structure.morePointsPlayers
            : languages.structure.morePoints}
        </DialogTitle>
        <DialogContent style={{ width: 350, maxWidth: "97%", paddingTop: 0 }}>
          {this.props.playerStats && !this.props.customPoints && (
            <FormControl>
              <InputLabel htmlFor="referee">
                {languages.structure.pointsType}
              </InputLabel>
              <Select
                style={{ width: 300 }}
                value={this.props.type}
                onChange={this.props.handleChange}
                inputProps={{
                  name: "type",
                  id: "type",
                }}
              >
                {this.props.types.map((type) => (
                  <MenuItem key={type.id} value={type.id}>
                    {type.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
          {this.props.type !== "3" &&
            this.props.type !== "4" &&
            this.props.type !== "5" && (
              <div>
                <TextField
                  margin="dense"
                  label={languages.general.name}
                  value={this.props.name}
                  name="name"
                  onChange={this.props.handleChange}
                  type="text"
                  fullWidth
                  disabled={
                    (this.props.customPoints || {}).type === "3" ||
                    (this.props.customPoints || {}).type === "4" ||
                    (this.props.customPoints || {}).type === "5"
                  }
                />

                <TextField
                  margin="dense"
                  label={languages.structure.abbr}
                  helperText={languages.structure.abbrHelper}
                  inputProps={{ maxLength: 3 }}
                  value={this.props.abbr}
                  name="abbr"
                  onChange={this.props.handleChange}
                  type="text"
                  fullWidth
                />
              </div>
            )}
          {!this.props.playerStats && (
            <FormGroup style={{ marginTop: 15, marginRight: -16 }}>
              <FormControlLabel
                control={
                  <Switch
                    checked={
                      this.props.showUnderResults ||
                      this.props.showUnderResults === undefined
                        ? true
                        : false
                    }
                    onChange={this.props.handleSwitch}
                    color="primary"
                    name="showUnderResults"
                  />
                }
                label={languages.structure.showPoints}
              />
              <FormHelperText style={{ marginTop: 0 }}>{""}</FormHelperText>
            </FormGroup>
          )}
          {!this.props.playerStats && (
            <FormGroup style={{ marginTop: 5, marginRight: -16 }}>
              <FormControlLabel
                control={
                  <Switch
                    checked={this.props.addPointsToPouleScore ? true : false}
                    onChange={this.props.handleSwitchAddPointsToPouleScore}
                    color="primary"
                    name="addPointsToPouleScore"
                  />
                }
                label={languages.structure.addPointsToPouleScore}
              />
              <FormHelperText style={{ marginTop: 0 }}>
                {languages.structure.addPointsToPouleScoreDescription}
              </FormHelperText>
            </FormGroup>
          )}
          {this.props.deleteConfirm && (
            <div style={{ color: "red" }}>
              {languages.tournament.areYouSure}
            </div>
          )}
        </DialogContent>
        <DialogActions>
          {this.props.customPoints && (
            <Button onClick={this.props.handleDelete} color="secondary">
              {languages.general.delete}
            </Button>
          )}
          <Button onClick={this.props.toggleDialog} color="primary">
            {languages.general.cancel}
          </Button>
          <Button
            onClick={this.props.handleSubmit}
            disabled={this.props.submitDisabled}
            variant="contained"
            color="primary"
            type="submit"
          >
            {this.props.customPoints
              ? languages.general.save
              : languages.general.add}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
